/** @jsxImportSource @emotion/react */
import React from 'react'
import { StaffTeamForm, StaffTeamPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/StaffTeamContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, staffTeamManagement } = breadcrumbItems

const StaffCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <StaffTeamForm />
        </div>
        <div css={styles.right}>
          <StaffTeamPreview />
        </div>
      </div>
    </Provider>
  )
}

export default StaffCreate;
